import * as misc from "./misc.js";

export function init() {
  window.onscroll = function () {
    doStickyHeader();
  };
  window.scrollClick = misc.scrollClick;

  var header = jQuery(".navbar-container");
  jQuery("*[data-vc-full-width]").addClass("vc_fullwidth");

  // Get the offset position of the navbar
  var sticky = 50;

  load_minicart();

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function doStickyHeader() {
    if (jQuery(window).scrollTop() > sticky) {
      jQuery(".topheader").addClass("sticky-header");
    } else {
      jQuery(".topheader").removeClass("sticky-header");
    }
  }

  jQuery(".remove-lazy").find("img").removeAttr("loading", "lazy");

  jQuery(".signup").on("click", function () {
    jQuery("#input_9_1").val(jQuery("input[name='email']").val());
  });

  jQuery("*[data-href]").on("click", function () {
    window.location = jQuery(this).data("href");
  });

  jQuery("button[name='resetpassword']").on("click", function () {
    resetpassword();
  });

  jQuery(".logout").on("click", function () {
    user.logout();
  });

  jQuery(".sendresetform input[name='sendreset']").on("click", function () {
    var emailfield = jQuery(".sendresetform input[name='email']");
    emailfield.removeClass("error");
    if (emailfield.val() == "") {
      emailfield.addClass("error");
    } else {
      jQuery.post(
        base.ajaxurl,
        {
          action: "sendreset",
          email: emailfield.val(),
          nonce: jQuery(".sendresetform").attr("data-nonce"),
        },
        function (r) {
          var r = JSON.parse(r);
          if (r.r == "notfound") {
            jQuery(".sendresetresult").html(
              "Sorry, we couldn't find those details.",
            );
            emailfield.addClass("error");
          } else {
            jQuery(".sendresetresult").html(
              "Thanks. We have send you a reset email.",
            );
            jQuery(".sendresetform").hide();
          }
        },
      );
    }
  });

  // jQuery("body").on("click", ".loginbtn", function () {
  //     var loginform = jQuery(this).parent(".form");
  //     var email = loginform.find(".inputemail");
  //     var password = loginform.find(".inputpassword");
  //     jQuery(".loginpopup .form .errors").remove();
  //     var errors = "";
  //     email.removeClass("error");
  //     password.removeClass("error");
  //     console.log("logging in")
  //     jQuery(this).val("Please Wait...");

  //     if (email.val() == "") {
  //         email.addClass("error");
  //     }
  //     if (password.val() == "") {
  //         password.addClass("error");
  //     }
  //     if (errors == "") {
  //         // do login
  //         jQuery.post(base.ajaxurl, {
  //             action: "wp_login",
  //             email: email.val(),
  //             password: password.val()
  //         }, function (r) {

  //             var r = JSON.parse(r);

  //             if (r.error == "notfound") {
  //                 jQuery(this).val("Login");
  //                 loginform.append(`<div class="errors">Sorry, we couldn't find those details. Please try again</div>`)
  //             }
  //             else if (r.loggedin) {
  //                 user.userLoggedIn();
  //             }
  //         })
  //     }

  // });

  jQuery(".slidedown").on("click", function () {
    var slidediv = jQuery(this).data("slidediv");
    if (jQuery("." + slidediv).hasClass("open")) {
      jQuery("." + slidediv).slideUp();
      jQuery("." + slidediv).removeClass("open");
    } else {
      jQuery("." + slidediv).addClass("open");
      jQuery("." + slidediv).slideDown();
    }
  });

  jQuery(".showhide_button").on("click", function () {
    var thisid = jQuery(this).data("id");

    var content = jQuery('.showhide_content[data-id="' + thisid + '"]');

    content.toggleClass("open");
    jQuery(this).toggleClass("open");
    if (jQuery(this).hasClass("open")) {
      jQuery(this).html("Read Less");
    } else {
      jQuery(this).html("Read More");
    }
  });

  jQuery(".container").on(
    "click",
    ".gform_button.button[type='submit']",
    function () {
      jQuery(this).val("Please Wait...");
    },
  );

  jQuery(".scrollto").click(function () {
    // console.log("scrollto clicked")
    scrollClick(this);
  });

  jQuery("#zip-tagline").remove();
  jQuery("#ppcp-messages").remove();
  jQuery("afterpay-placement").remove();

  jQuery("form#commentform").attr("enctype", "multipart/form-data");
}

export function load_minicart() {
  jQuery.post(
    base.ajaxurl,
    {
      action: "load_minicart",
    },
    function (r) {
      var r = JSON.parse(r);
      jQuery(".minicart .headerpopup").html(r.html);
    },
  );
}
